import styled from "styled-components";

interface ColorSelectorProps {
    color?: string;
    onClick?: (color: string) => void;
}

const ColorSelector: React.FC<ColorSelectorProps> = (p) => {
    const changeColor = () => {
        if (p.onClick) {
            p.onClick(p.color || '#B27B65FF');
        }
    }
    return (
        <ColorOption onClick={() => changeColor() } color={p.color}>
            <TextContainer>{p.color}</TextContainer>
        </ColorOption>
    );

    
}

const TextContainer = styled.div`
    color:white;
    font-weight: bold;
    font-size: 0.8rem;
`;
const ColorOption = styled.div<{ color?: string }>`
    display: flex;
    flex-direction: row;
    margin-right: 1rem;
    padding: 0.5rem;
    border-radius: 0.5rem;
    text-align:center;
    justify-content:center;
    width: 3.8rem;
    height: 3.8rem;
    background-color: ${(props) => props.color || '#B27B65FF'};
    &:hover {
        transform: scale(0.95);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
        transition: all 250ms;
    }
    &:active{
        transform: translateY(0px);
        box-shadow: none;
        transition: all 250ms;
    }
`
export default ColorSelector;